import { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Bracket from './Bracket.js';
import StandingsSection from './StandingsSection.js';
import SeasonLeadersSection from './SeasonLeadersSection.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';

import { getDoc, doc } from "firebase/firestore";
import { db } from '../firebase.js';
import { useLeagueData } from '../contexts/LeagueDataContext.js';
import { useConfig } from '../contexts/ConfigContext.js';

const Seasons = () => {
  const { seasonID } = useParams();
  const navigate = useNavigate();
  const { teams: allTeams, seasonTeams: allSeasonTeams, games: allGames, dataLoaded } = useLeagueData(['teams', 'seasonTeams', 'games']);
  const config = useConfig();
  const currentSeason = config.currentSeason;

  useEffect(() => {
    if (!config.configLoaded || !seasonID) return;
    if (Number(seasonID) > Number(currentSeason)) {
      navigate(`/seasons/${currentSeason}`, { replace: true });
    }
  }, [config.configLoaded, seasonID, currentSeason]); // eslint-disable-line react-hooks/exhaustive-deps

  const [games, setGames] = useState([])
  const [teams, setTeams] = useState([])
  const [dataReady, setDataReady] = useState(false);
  const [seasonData, setSeasonData] = useState({
    leaders: [],
    teams: []
  })

  useEffect(() => {
    getSeasonData();
  }, [])

  useEffect(() => {
    if (!dataLoaded) return;

    const seasonTeamsForSeason = allSeasonTeams.filter(st => st.season == seasonID);
    setTeams(allTeams.map(t => {
      const st = seasonTeamsForSeason.find(st => st.teamID === t.id);
      return { ...t, seed: st?.seed || '', conference: st?.conference || '' };
    }));

    const filtered = allGames
      .filter(g => g.season == parseInt(seasonID))
      .filter(g => g.status !== 'pending');
    setGames(filtered);
    setDataReady(true);
  }, [dataLoaded, allTeams, allGames]);

  const getSeasonData = async () => {
    const seasonRef = doc(db, 'seasons', seasonID);
    const seasonSnapshot = await getDoc(seasonRef);
    const seasonData = seasonSnapshot.data();
    setSeasonData(seasonData);
  }

  function gamesExistForSeason () {
    return games.length > 0
  }

  if (dataReady == false) {
    return (
      <div className="HomepageUpdated">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="HomepageUpdated">
        <div className="league-content">
          <div className="league-homepage">

            <nav className="homepage-nav">
              <span className="homepage-nav-label">Season { seasonID }{ gamesExistForSeason() ? '' : ' (No games yet)' }</span>
              <a className="homepage-anchor-link" href="#standings">Standings</a>
              <a className="homepage-anchor-link" href="#season-leaders">Season Leaders</a>
            </nav>
            <hr className="section-divider" />

            { (currentSeason !== seasonID || config.showPlayoffBracket) && (
              <>
                <div className="homepage-section">
                  <Bracket games={games} teams={teams} isCurrentSeason={ currentSeason === seasonID } compact></Bracket>
                </div>
                <hr className="section-divider" />
              </>
            ) }

            <StandingsSection teams={seasonData.teams} conferences={seasonData.conferences} />
            { seasonData.teams?.length > 0 && <hr className="section-divider" /> }

            <SeasonLeadersSection leaders={seasonData.leaders} />
            { seasonData.leaders?.length > 0 && <hr className="section-divider" /> }

            { Number(currentSeason) > 1 && (
              <>
                <div className="homepage-section">
                  <p className="league-article-title">Results from Other Seasons</p>
                  <div className="homepage-other-seasons-links">
                    { Array.from({ length: Number(currentSeason) }, (_, i) => Number(currentSeason) - i)
                        .map(s => {
                          const isCurrentPage = String(s) === String(seasonID);
                          return (
                            <a
                              key={s}
                              className={ `homepage-anchor-link${isCurrentPage ? ' homepage-anchor-link-current' : ''}` }
                              href={`/seasons/${s}`}
                            >
                              { String(s) === String(currentSeason) ? `Season ${s} (Current)` : `Season ${s}` }
                            </a>
                          );
                        })
                    }
                  </div>
                </div>
                <hr className="section-divider" />
              </>
            ) }

          </div>
        </div>

        <Footer/>
      </div>
    );
  }
}

export default Seasons;
